export const stringsKey = "MessageSegmentPreview";
export const englishStrings = {
	encodingLabel: "Encoding",
	segmentsLabel: "Segments",
	charactersLabel: "Characters",
};
